<template>
    <div>
        <w-app :title="$t('module.pay_section_tools')">
            <template v-slot:leftToolbar>
                <ImportModel file-name="Rubrique.xlsx"/>
            </template>
            <template v-slot:rightToolbar>
                <v-btn
                    depressed
                    class="ma-2 white--text"
                    color="teal"
                    small
                    @click="dialog = true"
                >
                    {{ $t("common.import") }}
                    <v-icon right dark>mdi-import</v-icon>
                </v-btn>
                <v-btn
                    depressed
                    class="white--text"
                    color="red"
                    small
                    :loading="loading"
                    @click="saveAll"
                >
                    {{ $t('common.apply') }}
                    <v-icon right>mdi-database-plus</v-icon>
                </v-btn>

            </template>
            <template v-slot:content>
                <v-tabs
                    v-model="tab"
                    color="blue"
                    height="40"
                >
                    <v-tabs-slider></v-tabs-slider>
                    <v-tab>Rubriques Différentes</v-tab>
                    <v-tab>Rubriques Manquantes</v-tab>
                    <v-tab>Rubriques Supplémentaires</v-tab>
                    <v-tab>Rubriques Identiques</v-tab>
                </v-tabs>

                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-data-table
                            :headers="headers"
                            :items="compareStates"
                            hide-default-footer
                            class="elevation-15"
                            dense
                            disable-pagination
                            fixed-header
                            height="700"
                            :item-class="rowColor"
                            @click:row="itemClick"
                        >
                            <template v-slot:[`item.action`]="{ item }">
                                <v-menu bottom right>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            @click="itemClick(item)"
                                            icon
                                            color="blue darken-2"
                                            v-on="on">
                                            <v-icon>mdi-dots-horizontal</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list dense>
                                        <v-list-item
                                            v-if="securityStore.authorities['UPDATE_IMPORT_PARAM']"
                                            @click="$router.push({name: 'pay_section_tools.edit',params: { id: item.original.id }})"
                                        >
                                            <v-list-item-icon>
                                                <v-icon v-text="'mdi-pencil-box-multiple'" color="orange"></v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-title>{{ $t("common.edit") }}</v-list-item-title>
                                        </v-list-item>
                                        <v-list-item
                                            v-if="securityStore.authorities['UPDATE_IMPORT_PARAM']"
                                            @click="$router.push({name: 'pay_section_tools.delete',params: { id: item.original.id }})"
                                        >
                                            <v-list-item-icon>
                                                <v-icon v-text="'mdi-trash-can'" color="red"></v-icon>
                                            </v-list-item-icon>
                                            <v-list-item-title>{{ $t("common.delete") }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>
                            </template>
                            <template v-slot:[`item.code`]="{ item }">
                                <w-chip outlined :text="item.original.code"/>
                            </template>
                            <template v-slot:[`item.label`]="{ item }">
                                <compare-state-td
                                    :check="item.label"
                                    :original-value="item.original.label"
                                    :new-value="item.paySection.label"
                                    copy-import-value
                                />
                            </template>
                            <template v-slot:[`item.type`]="{ item }">
                                <compare-state-td
                                    :check="item.type"
                                    :original-value="$t(`pay_section.type_${item.original.type}`)"
                                    :new-value="$t(`pay_section.type_${item.paySection.type}`)"
                                />
                            </template>
                            <template v-slot:[`item.variable`]="{ item }">
                                <compare-state-td
                                    :check="item.variable"
                                    :original-value="item.original.variable"
                                    :new-value="item.paySection.variable"
                                />
                            </template>
                            <template v-slot:[`item.isAbsenceRetenue`]="{ item }">
                                <compare-state-td
                                    :check="item.isAbsenceRetenue"
                                    :original-value="$t(`pay_section.boolean_${item.original.isAbsenceRetenue}`)"
                                    :new-value="$t(`pay_section.boolean_${item.paySection.isAbsenceRetenue}`)"
                                />
                            </template>
                            <template v-slot:[`item.cotisable`]="{ item }">
                                <compare-state-td
                                    :check="item.cotisable"
                                    :original-value="$t(`pay_section.boolean_${item.original.cotisable}`)"
                                    :new-value="$t(`pay_section.boolean_${item.paySection.cotisable}`)"
                                />
                            </template>
                            <template v-slot:[`item.imposable`]="{ item }">
                                <compare-state-td
                                    :check="item.imposable"
                                    :original-value="$t(`pay_section.imposable_${item.original.imposable}`)"
                                    :new-value="$t(`pay_section.imposable_${item.paySection.imposable}`)"
                                />
                            </template>
                            <template v-slot:[`item.formule`]="{ item }">
                                <compare-state-td
                                    :check="item.formule"
                                    :original-value="item.original.formule"
                                    :new-value="item.paySection.formule"
                                    copy-import-value
                                />
                            </template>
                            <template v-slot:[`item.brute`]="{ item }">
                                <compare-state-td
                                    :check="item.brute"
                                    :original-value="$t(`pay_section.boolean_${item.original.brute}`)"
                                    :new-value="$t(`pay_section.boolean_${item.paySection.brute}`)"
                                />
                            </template>
                            <template v-slot:[`item.conge`]="{ item }">
                                <compare-state-td
                                    :check="item.conge"
                                    :original-value="$t(`pay_section.boolean_${item.original.conge}`)"
                                    :new-value="$t(`pay_section.boolean_${item.paySection.conge}`)"
                                />
                            </template>
                            <template v-slot:[`item.regularization`]="{ item }">
                                <compare-state-td
                                    :check="item.regularization"
                                    :original-value="$t(`pay_section.boolean_${item.original.regularization}`)"
                                    :new-value="$t(`pay_section.boolean_${item.paySection.regularization}`)"
                                />
                            </template>
                            <template v-slot:[`item.recapPrintable`]="{ item }">
                                <compare-state-td
                                    :check="item.recapPrintable"
                                    :original-value="$t(`pay_section.boolean_${item.original.recapPrintable}`)"
                                    :new-value="$t(`pay_section.boolean_${item.paySection.recapPrintable}`)"
                                />
                            </template>
                            <template v-slot:[`item.bulteinePrintable`]="{ item }">
                                <compare-state-td
                                    :check="item.bulteinePrintable"
                                    :original-value="$t(`pay_section.bulteine_printable_${item.original.bulteinePrintable}`)"
                                    :new-value="$t(`pay_section.bulteine_printable_${item.paySection.bulteinePrintable}`)"
                                />
                            </template>
                            <template v-slot:[`item.journalPrintable`]="{ item }">
                                <compare-state-td
                                    :check="item.journalPrintable"
                                    :original-value="$t(`pay_section.boolean_${item.original.journalPrintable}`)"
                                    :new-value="$t(`pay_section.boolean_${item.paySection.journalPrintable}`)"
                                />
                            </template>
                            <template v-slot:[`item.stateChargePrintable`]="{ item }">
                                <compare-state-td
                                    :check="item.stateChargePrintable"
                                    :original-value="$t(`pay_section.boolean_${item.original.stateChargePrintable}`)"
                                    :new-value="$t(`pay_section.boolean_${item.paySection.stateChargePrintable}`)"
                                />
                            </template>
                            <template v-slot:[`item.blockFormula`]="{ item }">
                                <compare-state-td
                                    :check="item.blockFormula"
                                    :original-value="$t(`pay_section.boolean_${item.original.blockFormula}`)"
                                    :new-value="$t(`pay_section.boolean_${item.paySection.blockFormula}`)"
                                />
                            </template>
                            <template v-slot:[`item.notWritable`]="{ item }">
                                <compare-state-td
                                    :check="item.notWritable"
                                    :original-value="$t(`pay_section.boolean_${item.original.notWritable}`)"
                                    :new-value="$t(`pay_section.boolean_${item.paySection.notWritable}`)"
                                />
                            </template>
                            <template v-slot:[`item.viewFormat`]="{ item }">
                                <compare-state-td
                                    :check="item.viewFormat"
                                    :original-value="item.original.viewFormat"
                                    :new-value="item.paySection.viewFormat"
                                    copy-import-value
                                />
                            </template>
                            <template v-slot:[`item.fixeInitial`]="{ item }">
                                <compare-state-td
                                    :check="item.fixeInitial"
                                    :original-value="$t(`pay_section.view_format_${item.original.fixeInitial}`)"
                                    :new-value="$t(`pay_section.view_format_${item.paySection.fixeInitial}`)"
                                />
                            </template>
                            <template v-slot:[`item.initValue`]="{ item }">
                                <compare-state-td
                                    :check="item.initValue"
                                    :original-value="item.original.initValue"
                                    :new-value="item.paySection.initValue"
                                />
                            </template>
                            <template v-slot:[`item.comptaCompte`]="{ item }">
                                <compare-state-td
                                    :check="item.comptaCompte"
                                    :original-value="item.original.comptaCompte"
                                    :new-value="item.paySection.comptaCompte"
                                    copy-import-value
                                />
                            </template>
                        </v-data-table>
                    </v-tab-item>
                    <v-tab-item>
                        <PaySectionTable
                            :pay-sections="missingPaySections"
                            parent-link="pay_section_tools"
                            :show-add-action="securityStore.authorities['UPDATE_IMPORT_PARAM']"
                        />
                    </v-tab-item>
                    <v-tab-item>
                        <PaySectionTable
                            :pay-sections="extraPaySections"
                            parent-link="pay_section_tools"
                            :show-update-action="securityStore.authorities['UPDATE_IMPORT_PARAM']"
                            :show-delete-action="securityStore.authorities['UPDATE_IMPORT_PARAM']"
                        />
                    </v-tab-item>
                    <v-tab-item>
                        <PaySectionTable
                            :pay-sections="identicalPaySections"
                            parent-link="pay_section_tools"
                            :show-update-action="securityStore.authorities['UPDATE_IMPORT_PARAM']"
                            :show-delete-action="securityStore.authorities['UPDATE_IMPORT_PARAM']"
                        />
                    </v-tab-item>
                </v-tabs-items>
            </template>
        </w-app>
        <v-dialog
            v-model="dialog"
            persistent
            max-width="500"
        >
            <v-card>
                <v-toolbar flat height="40" dark color="teal">
                    <v-toolbar-title></v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <v-container fluid>
                        <v-row dense>
                            <v-col cols="12">
                                <w-file-input
                                    v-model="file"
                                    :rules="[mxRules.required]"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-divider/>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn
                        depressed
                        outlined
                        color="teal"
                        @click="dialog = false"
                    >
                        {{ $t('common.close') }}
                        <v-icon right>mdi-close</v-icon>
                    </v-btn>
                    <v-btn
                        depressed
                        class="white--text"
                        color="teal"
                        :loading="loading"
                        @click="compareState"
                    >
                        {{ $t('common.import') }}
                        <v-icon right>mdi-import</v-icon>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <router-view/>
    </div>
</template>

<script>
import {ref} from "vue";
import useValidation from "@/use/Validation";
import CompareStateTd from "@/views/Tools/Components/CompareStateTd.vue";
import PaySectionTable from "@/views/PaySection/Components/PaySectionTable.vue"
import axios from "axios";
import useSharedData from "@/use/SharedData";
import ImportModel from "@/views/Tools/Components/ImportModel.vue";
import {useSecurityStore} from "@/stores/Security";

export default {
    name: "PaySectionImport",
    components: {ImportModel, CompareStateTd, PaySectionTable},
    setup() {
        const {mxRules} = useValidation();

        const {itemColor, selectedOne, loading} = useSharedData();

        const securityStore = useSecurityStore();

        const dialog = ref(false);
        const tab = ref(null);
        const file = ref(null);
        const compareStates = ref([]);
        const missingPaySections = ref([]);
        const extraPaySections = ref([]);
        const identicalPaySections = ref([]);

        const headers = [
            {
                text: "...",
                align: "start",
                sortable: false,
                value: "action",
            },
            {
                text: "Code",
                align: "start",
                sortable: false,
                value: "code",
            },
            {
                text: "Libellé",
                align: "start",
                sortable: false,
                value: "label",
            },
            {
                text: "Type Valeur",
                align: "start",
                sortable: false,
                value: "type",
            },
            {
                text: "Type Temps",
                align: "start",
                sortable: false,
                value: "variable",
            },
            {
                text: "Retenue absence",
                align: "start",
                sortable: false,
                value: "isAbsenceRetenue",
            },
            {
                text: "Cotisable",
                align: "start",
                sortable: false,
                value: "cotisable",
            },
            {
                text: "Imposable",
                align: "start",
                sortable: false,
                value: "imposable",
            },
            {
                text: "Formule",
                align: "start",
                sortable: false,
                value: "formule",
            },
            {
                text: "Brute",
                align: "start",
                sortable: false,
                value: "brute",
            },
            {
                text: "Congé",
                align: "start",
                sortable: false,
                value: "conge",
            },
            {
                text: "Régule",
                align: "start",
                sortable: false,
                value: "regularization",
            },
            {
                text: "Impr. recap",
                align: "start",
                sortable: false,
                value: "recapPrintable",
            },
            {
                text: "Impr. colonne",
                align: "start",
                sortable: false,
                value: "bulteinePrintable",
            },
            {
                text: "Impr. journale",
                align: "start",
                sortable: false,
                value: "journalPrintable",
            },
            {
                text: "Impr. etat des charges",
                align: "start",
                sortable: false,
                value: "stateChargePrintable",
            },
            {
                text: "Ignorer la formule",
                align: "start",
                sortable: false,
                value: "blockFormula",
            },
            {
                text: "Bloquer Saisie",
                align: "start",
                sortable: false,
                value: "notWritable",
            },
            {
                text: "Affichage (Format)",
                align: "start",
                sortable: false,
                value: "viewFormat",
            },
            {
                text: "Type saisie",
                align: "start",
                sortable: false,
                value: "fixeInitial",
            },
            {
                text: "Valeur Initiale",
                align: "start",
                sortable: false,
                value: "initValue",
            },
            {
                text: "Compte",
                align: "start",
                sortable: false,
                value: "comptaCompte",
            },
        ];

        function compareState() {
            loading.value = true;
            let formData = new FormData();
            formData.append('file', file.value);
            axios.post(`/tools/getPaySectionCompareState`, formData).then(response => {
                compareStates.value = response.data.compareStates;
                missingPaySections.value = response.data.missingPaySections;
                extraPaySections.value = response.data.extraPaySections;
                identicalPaySections.value = response.data.identicalPaySections;
                dialog.value = false;
                // file.value = null;
            }).finally(() => {
                loading.value = false;
            });
        }

        const selected = ref([]);

        function isSelected(code) {
            return selected.value.findIndex(p => p.code === code) !== -1;
        }

        function addPaySection(paySection) {
            selected.value.push(paySection);
        }

        function removePaySection(code) {
            let index = selected.value.findIndex(p => p.code === code);
            selected.value.splice(index, 1);
        }

        function saveAll() {
            loading.value = true;
            axios.post(`/paySections/saveAll`, selected.value).then(response => {
                let index;
                response.data.forEach(element => {
                    index = compareStates.value.findIndex(e => e.original.code === element.code);
                    if (index !== -1)
                        compareStates.value.splice(index, 1);

                    index = missingPaySections.value.findIndex(e => e.code === element.code);
                    if (index !== -1)
                        missingPaySections.value.splice(index, 1);

                    index = selected.value.findIndex(e => e.code === element.code);
                    if (index !== -1)
                        selected.value.splice(index, 1);
                });
            }).finally(() => {
                loading.value = false;
            });
        }

        function rowColor(item) {
            if (item.original.code === selectedOne.value.code) {
                return itemColor.value;
            }
        }

        function itemClick(item) {
            selectedOne.value = item.original;
        }

        return {
            securityStore,
            tab,
            mxRules,
            dialog,
            loading,
            file,
            compareStates,
            missingPaySections,
            extraPaySections,
            identicalPaySections,
            selected,
            headers,
            compareState,
            isSelected,
            addPaySection,
            removePaySection,
            saveAll,
            rowColor,
            itemClick,
        }
    }
}
</script>